import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const ACCENT = '#38B6EF';
const ACCENT_RGB = '56,182,239';
const DIVIDER = 'rgba(255,255,255,0.12)';
const ERROR = '#F87171';
export function EditorialField({ label, index, htmlFor, error, hint, right, children, }) {
    return (_jsxs("div", { "data-anim": "form-field", className: "apolo-field relative", children: [_jsxs("div", { className: "flex items-center justify-between mb-1", children: [_jsxs("span", { className: "flex items-center gap-3 font-mono font-bold uppercase", style: {
                            fontSize: '10px',
                            letterSpacing: '0.22em',
                            color: 'rgba(255,255,255,0.55)',
                        }, children: [_jsx("span", { "aria-hidden": "true", style: { color: `rgba(${ACCENT_RGB},0.85)` }, children: index }), _jsx("label", { htmlFor: htmlFor, className: "cursor-pointer", children: label })] }), right] }), _jsxs("div", { className: "apolo-field-rule relative", style: { borderBottom: `1px solid ${error ? ERROR : DIVIDER}` }, children: [children, _jsx("span", { "aria-hidden": true, className: "apolo-field-underline", style: { background: ACCENT } })] }), error ? (_jsxs("p", { role: "alert", className: "mt-2 font-mono uppercase", style: {
                    fontSize: '10px',
                    letterSpacing: '0.18em',
                    color: ERROR,
                }, children: [_jsx("span", { "aria-hidden": "true", children: "\u2014 " }), _jsx("span", { children: error })] })) : hint ? (_jsx("p", { className: "mt-2", style: {
                    fontSize: '11px',
                    color: 'rgba(255,255,255,0.4)',
                    letterSpacing: '0.01em',
                }, children: hint })) : null, _jsx("style", { children: `
        .apolo-field-underline {
          position: absolute;
          left: 0;
          bottom: -1px;
          height: 1px;
          width: 0;
          transition: width 0.35s cubic-bezier(0.4, 0, 0.2, 1);
          pointer-events: none;
        }
        .apolo-field:focus-within .apolo-field-underline {
          width: 100%;
        }
        .apolo-field input::placeholder {
          color: rgba(255,255,255,0.25);
          font-weight: 400;
        }
        .apolo-field input:-webkit-autofill,
        .apolo-field input:-webkit-autofill:hover,
        .apolo-field input:-webkit-autofill:focus {
          -webkit-text-fill-color: #fff !important;
          -webkit-box-shadow: 0 0 0 1000px #080e1c inset !important;
          caret-color: #fff;
          transition: background-color 9999s ease-in-out 0s;
        }
      ` })] }));
}
export const editorialInputStyle = {
    width: '100%',
    background: 'transparent',
    outline: 'none',
    fontWeight: 500,
    color: '#fff',
    fontSize: '16px',
    letterSpacing: '0.01em',
    padding: '10px 0 12px',
    border: 'none',
};
export function EditorialSubmit({ loading, label, loadingLabel = 'Enviando…' }) {
    return (_jsxs("button", { type: "submit", "data-anim": "form-submit", disabled: loading, className: "apolo-submit group relative flex items-center justify-between w-full px-6 py-4 font-bold transition-all duration-300 disabled:opacity-60 disabled:cursor-not-allowed", style: {
            background: ACCENT,
            color: '#061a2c',
            borderRadius: 0,
            fontSize: '13px',
            letterSpacing: '0.22em',
            textTransform: 'uppercase',
            fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
            boxShadow: loading ? 'none' : `0 10px 30px rgba(${ACCENT_RGB},0.35)`,
        }, children: [_jsxs("span", { className: "flex items-center gap-3", children: [loading ? (_jsx("span", { className: "inline-block w-3.5 h-3.5 rounded-full border-2 animate-spin", style: { borderColor: '#061a2c', borderTopColor: 'transparent' } })) : (_jsx("span", { className: "inline-block w-2 h-2 rounded-full", style: { background: '#061a2c' } })), loading ? loadingLabel : label] }), _jsx("svg", { width: "16", height: "16", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2.8", className: "transition-transform duration-300 group-hover:translate-x-1", children: _jsx("path", { d: "M5 12h14M13 6l6 6-6 6", strokeLinecap: "round", strokeLinejoin: "round" }) }), _jsx("style", { children: `
        .apolo-submit:hover:not(:disabled) {
          background: #5cc3f2 !important;
        }
      ` })] }));
}
export function EditorialAlert({ message }) {
    return (_jsxs("div", { role: "alert", className: "flex items-start gap-3 pl-4 py-3", style: {
            borderLeft: `2px solid ${ERROR}`,
            background: 'rgba(248,113,113,0.06)',
        }, children: [_jsx("span", { className: "shrink-0 font-mono font-bold uppercase pt-0.5", style: {
                    fontSize: '10px',
                    letterSpacing: '0.2em',
                    color: ERROR,
                }, children: "Error \u2014\u2014" }), _jsx("p", { className: "text-[13px] leading-relaxed", style: { color: 'rgba(255,255,255,0.9)' }, children: message })] }));
}
//# sourceMappingURL=EditorialField.js.map